import type { MailboxInfo } from 'owa-client-types';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * Make sure this isn't imported in the analytics worker
 *	> 'owa-feature-flags' import is restricted from being used. Feature flags have to be passed in the analytics worker initialization [analytics-worker-lint] */
import { isFeatureEnabled } from 'owa-feature-flags';
import { getAccountScopeUserSettings } from './getAccountScopeUserSettings';
import isConsumer from '../utils/isConsumer';

const PREMIUM_CONSUMER_OPTION = 'PremiumConsumerSetting';
const PREMIUM_CONSUMERBUSINESS_OPTION = 'IsBusinessConsumerOptions';

export default function isPremiumConsumer(mailboxInfo: MailboxInfo): boolean {
    if (!isConsumer(undefined, mailboxInfo)) {
        return false;
    }

    const settings = getAccountScopeUserSettings(mailboxInfo);
    if (settings.SessionSettings?.IsPremiumConsumerMailbox) {
        return true;
    }

    const primeSettingsItems = settings.PrimeSettings?.Items;
    if (isFeatureEnabled('auth-vsbisPremium')) {
        const primeIsBusinessConsumerSetting: any = primeSettingsItems?.filter(
            item => item?.Id === PREMIUM_CONSUMERBUSINESS_OPTION
        );
        if (primeIsBusinessConsumerSetting?.[0]?.Value.options?.[0]?.isBusinessConsumer === true) {
            return true;
        }
    }

    const primePremiumConsumerSetting: any = primeSettingsItems?.filter(
        item => item?.Id === PREMIUM_CONSUMER_OPTION
    );
    return primePremiumConsumerSetting?.[0]?.Value ?? false;
}
